__turbopack_context__.v({
  "authorLabel": "style-module-scss-module__lD8h8a__authorLabel",
  "avatar": "style-module-scss-module__lD8h8a__avatar",
  "infoWrapper": "style-module-scss-module__lD8h8a__infoWrapper",
  "personCard": "style-module-scss-module__lD8h8a__personCard",
  "role": "style-module-scss-module__lD8h8a__role",
});
